import axios from 'axios';

const get = async () =>{
    const response = await axios.get('/reservations/vue/resources/policy_and_terms');
    return response.data.data;
}

export default get;

